// react
import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";

// third-party
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
// application
import CategorySidebar from './CategorySidebar';
import PageHeader from '../shared/PageHeader';
import ProductsView from './ProductsView';
import { sidebarClose } from '../../store/sidebar';

// data stubs
import store from '../../store/store'
import categoryes from '../../data/shopFilters';
import theme from '../../data/theme';
import shopCategoryes from '../../data/shopFilters';
import { chandgeCategory } from '../../store/shop'

function ShopPageCategory(props) {
    
    const location = useLocation()
    const {
        columns,
        viewMode,
        sidebarPosition,
        match 
    } = props;
    const dispatch = useDispatch()
    const products = useSelector(state => state.shop.products)
    const categoryFilter = useSelector(state => state.shop.filters)

    const breadcrumb = [
        { title: 'Главная', url: '/' },
        // { title: category.name, url: '/shop/category/' + category.type },
    ];
    useEffect(() => {
        const catId = match.params.categoryId || match.params.categoryName;
        if (catId) {
            dispatch(chandgeCategory(catId));
        }
    }, [match.params.categoryId, match.params.categoryName, dispatch]);

    

    

    let content;
    let sidebar;
    const offcanvas = columns === 3 ? 'mobile' : 'always';

    if (columns > 3) {
        content = (
            <div className="container">
                <div className="block">
            
                

                    <ProductsView
                        products={products}
                        layout={viewMode}
                        grid={`grid-${columns}-full`}
                        limit={15}
                        offcanvas={offcanvas}
                    />
                </div>
                
                {<CategorySidebar filters={categoryFilter} offcanvas={offcanvas} />}
            </div>
        );
    } else {
        if (categoryFilter != null){
            sidebar = (
            
                <div className="shop-layout__sidebar">{<CategorySidebar filters={categoryFilter} offcanvas={offcanvas} />}</div>
                // <div className="shop-layout__sidebar"></div>
            );
        } else {
            sidebar = (
            
                // <div className="shop-layout__sidebar">{<CategorySidebar filters={categoryFilter} offcanvas={offcanvas} />}</div>
                <div className="shop-layout__sidebar"></div>
            );
        }
        

        content = (
            <div className="container">
                <div className={`shop-layout shop-layout--sidebar--${sidebarPosition}`}>
                    {sidebarPosition === 'start' && sidebar}
                    <div className="shop-layout__content">
                        <div className="block">
                            <ProductsView
                                products={products}
                                layout={viewMode}
                                grid="grid-3-sidebar"
                                limit={15}
                                offcanvas={offcanvas}
                            />
                        </div>
                    </div>
                    {sidebarPosition === 'end' && sidebar}
                </div>
            </div>
        );
    }
    const data = ""
    const Example = ({ data }) => <img src={`data:image/jpeg;base64,${data}`} />
    return (
        <React.Fragment>
            <Helmet>
                <title>{`Товары по категориям — ${theme.name}`}</title>
   
            </Helmet>

            <PageHeader header={"Каталог"}  />
            
            {content}
        </React.Fragment>
    );
}

ShopPageCategory.propTypes = {
    /**
     * number of product columns (default: 3)
     */
    columns: PropTypes.number,
    /**
     * mode of viewing the list of products (default: 'grid')
     * one of ['grid', 'grid-with-features', 'list']
     */
    viewMode: PropTypes.oneOf(['grid', 'grid-with-features', 'list']),
    /**
     * sidebar position (default: 'start')
     * one of ['start', 'end']
     * for LTR scripts "start" is "left" and "end" is "right"
     */
    sidebarPosition: PropTypes.oneOf(['start', 'end']),
};

ShopPageCategory.defaultProps = {
    columns: 3,
    viewMode: 'grid',
    sidebarPosition: 'start',
};

const mapStateToProps = (state) => ({
    sidebarState: state.sidebar,
});

const mapDispatchToProps = {
    sidebarClose,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopPageCategory);
